import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useDocumentList } from '../../Hooks/Features/WelcomeKit/useDocumentList';
import { SkeletonDataTable } from '../Loader/Loader';
import { dateConvert } from '../../utils/Helper';


const DocumentList = ({ onPrev, onNext, data, readOnly }) => {
    const { documents, dateBodyTemplate, reasonBodyTemplate, submittedBodyTemplate, srNoBodyTemplate, loader, handleSubmit } = useDocumentList({ data, onNext, readOnly })

    return (
        <>
            <div className='d-flex justify-content-center mx-1'>
                <div className='w100 my-2'>
                    <div>
                        <h5 className='welcome-text my-2 mb-4'>Document Checklist</h5>
                        <div className='d-flex justify-content-between'>
                            <span><b>Name: </b>{data?.employee?.user_display_name}</span>
                            <span><b>Employee Id: </b>{data?.employee?.employee_id}</span>
                            <span><b>Employment Type: </b>{data?.employee?.employment_type}</span>
                            <span><b>Joining Date: </b> {dateConvert(data?.employee?.joining_date, "day-mon-year")}</span>
                        </div>
                    </div>
                    <div className='my-4'>
                        {
                            loader ? <SkeletonDataTable numSkeletons={20} /> :
                                <DataTable value={documents} responsiveLayout="scroll">
                                    <Column header="Sr No" body={srNoBodyTemplate} style={{ width: '60px', textAlign: 'center' }} />
                                    <Column field="document_name" header="Document Name" />
                                    <Column
                                        field="submitted"
                                        header="Submitted"
                                        body={submittedBodyTemplate}
                                        style={{ textAlign: 'center' }}
                                    />
                                    <Column
                                        field="reason"
                                        header="Reason"
                                        body={reasonBodyTemplate}
                                    />
                                    <Column
                                        field="expectedDateOfSubmission"
                                        header="Expected Date of Submission"
                                        body={dateBodyTemplate}
                                    />
                                </DataTable>
                        }
                    </div>

                </div>

            </div>
            {
                !readOnly &&
                <div className='d-flex gap-2 justify-content-between position-fixed w95 bottom-0 end-0 px-4 pb-2 bg-white'>
                    <div>
                        <p>Verified by: <strong> {data?.commonDetails?.hr_name}</strong></p>
                    </div>
                    <div className='d-flex gap-2'>
                        <button className='btn-default' onClick={onPrev}>Previous</button>
                        <button className='btn-primary' onClick={handleSubmit}>Proceed</button>
                    </div>
                </div>
            }
        </>

    );
};

export default DocumentList;
